"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: Refac codewise + design
const react_1 = __importDefault(require("react"));
const building_blocks_ui_common_1 = require("@acko-tech/building-blocks.ui.common");
const Container = (0, building_blocks_ui_common_1.styled)(building_blocks_ui_common_1.Flex) `
  min-height: 26px;
`;
const BounceAnimation = (0, building_blocks_ui_common_1.keyframes) `
  0% { margin-bottom: 0; }
  50% { margin-bottom: 15px }
  100% { margin-bottom: 0 }
`;
const Dot = building_blocks_ui_common_1.styled.div `
  background-color: #fff;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  /* Animation */
  animation: ${BounceAnimation} 1.4s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s
    infinite both;
  /* animation: ${BounceAnimation} 0.5s linear infinite; */
  animation-delay: ${(props) => props.delay};
`;
const LoadingDots = () => {
    return (react_1.default.createElement(Container, { alignItems: "flex-end", justifyContent: "center" },
        react_1.default.createElement(Dot, { delay: "0s" }),
        react_1.default.createElement(Dot, { delay: ".1s" }),
        react_1.default.createElement(Dot, { delay: ".2s" })));
};
exports.default = LoadingDots;
//# sourceMappingURL=button-loader.js.map